// extracted by mini-css-extract-plugin
module.exports = {"icon":"b429494557--icon--Hy4vL","icon--opened":"b429494557--icon--opened--R5hx2"};